import script from "./listEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./listEvent.vue?vue&type=script&setup=true&lang=js"

import "./listEvent.vue?vue&type=style&index=0&id=c8a65fbc&scoped=true&lang=css"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8a65fbc"]])

export default __exports__